import React from 'react'
import Comingsoon from '../components/organisms/Comingsoon'

function Marketplace() {
    return (
        <>
            <Comingsoon />
        </>
    )
}

export default Marketplace
